function portalApiBaseUrl() {
  // Same-origin in prod, localhost:8000 in local Docker.
  const isLocalDevHost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  return isLocalDevHost ? "http://localhost:8000/api" : `${window.location.origin}/api`;
}

async function portalFetch(path, { method = "GET", body = null } = {}) {
  const url = `${portalApiBaseUrl()}${path}`;
  const res = await fetch(url, {
    method,
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
    credentials: "include",
  });

  const text = await res.text();
  let json = null;
  try {
    json = text ? JSON.parse(text) : null;
  } catch {
    // non-json
  }

  if (!res.ok) {
    const err = new Error(json?.error || `HTTP ${res.status}`);
    err.status = res.status;
    err.payload = json;
    throw err;
  }

  return json;
}

export function portalMe() {
  return portalFetch("/portal/me");
}

export function portalLogin({ username, password, realm }) {
  return portalFetch("/portal/login", { method: "POST", body: { username, password, realm } });
}

export function portalLogout() {
  return portalFetch("/portal/logout", { method: "POST" });
}

